import { render } from "./imageBlock.vue?vue&type=template&id=2e5d192e&ts=true"
import script from "./imageBlock.vue?vue&type=script&lang=ts"
export * from "./imageBlock.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__